import { gql } from 'graphql-request'

export const LATEST_UPDATE_IN_APP_PURCHASE = gql`
  query LatestUpdateInAppPurchasesAppleTransaction {
    latestUpdateInAppPurchasesAppleTransaction
  }
`
